import type { GraphTurnStamp } from '@super/shared-types'
import { turnWallMs } from '@super/shared-types'

function clock(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  })
}

function seconds(ms: number): string {
  return `${(ms / 1000).toFixed(1)}s`
}

export function TurnHeader({
  stamp,
  index,
  modelMs,
  flash,
}: {
  stamp: GraphTurnStamp
  index: number
  modelMs: number
  flash: boolean
}) {
  return (
    <div
      className={`mb-3 rounded-md border bg-muted/40 px-3 py-2 transition-colors duration-500 ${flash ? 'border-primary' : 'border-border'}`}
    >
      <div className="flex items-center gap-2 text-xs text-muted-foreground mb-1 flex-wrap">
        <span className="font-medium uppercase tracking-wide">
          Turn {index}
        </span>
        <span className="text-border">·</span>
        <span className="font-mono">received {clock(stamp.receivedAt)}</span>
        <span className="text-border">·</span>
        <span className="font-mono">replied {clock(stamp.sentAt)}</span>
        <span className="text-border">·</span>
        <span>{seconds(turnWallMs(stamp))} wall</span>
        <span className="text-border">·</span>
        <span>{seconds(modelMs)} in models</span>
      </div>
      <p className="text-sm text-foreground leading-snug">
        {stamp.inboundText}
      </p>
    </div>
  )
}
